export const getDimensionalityForExamplePage = (dimensionality: string) => {
  if (dimensionality === 'thousand') {
    return 'thousand';
  } else if (dimensionality === 'million') {
    return 'million';
  } else if (dimensionality === 'billion') {
    return 'billion';
  } else {
    return '';
  }
};
export const getGenderForExamplePage = (gender: string) => {
  if (gender === 'male') {
    return 'Male';
  } else if (gender === 'female') {
    return 'Female';
  } else if (gender === 'gender-neutral') {
    return 'Gender-Neutral';
  } else {
    return '';
  }
};
